export default class Instructor {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    id: 'validString',
    customerID: 'validString',
    email: 'validString',
    firstName: 'validString',
    lastName: 'validString',
    disabled: 'boolean',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createInstructor(instructorID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/instructor/new';
    req.body = { userID: instructorID };
    return await req.exec();
  }
  async updateInstructor(instructorObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/instructor/' + instructorObj.id;
    req.body = { disabled: instructorObj.disabled };
    return await req.exec();
  }
  async deleteInstructor(instructorID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/instructor/' + instructorID;
    return await req.exec();
  }
  async getInstructor(instructorID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/instructor/' + instructorID;
    return await req.exec();
  }
  async getAllInstructors(expanded = false) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/instructors/' + (expanded ? '?expandedInstructor=true' : '');
    return await req.exec();
  }
  async upsertInstructorCourses(instructorID, courseIDs) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/instructor/' + instructorID + '/course/';
    req.body = { courseIDs };
    return await req.exec();
  }
  async getInstructorCourses(instructorID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/instructor/' + instructorID + '/course/';
    return await req.exec();
  }
  async upsertInstructorRegions(instructorID, regionIDs) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/instructor/' + instructorID + '/region/';
    req.body = { regionIDs };
    return await req.exec();
  }
  async getInstructorRegions(instructorID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/instructor/' + instructorID + '/region/';
    return await req.exec();
  }
  async getInstructorEvents(instructorID, { startTime, endTime, expandSessions }) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/instructor/' + instructorID + '/events/';
    req.body = { startTime, endTime, expandSessions };
    return await req.exec();
  }
}
